<template></template>

<script>
    import {mapGetters, createNamespacedHelpers} from 'vuex'

    const {mapActions, mapGetters: gettersUser} = createNamespacedHelpers('users');
    export default {
        name: "PushNotification",
        methods: {
            ...mapActions(['updateFcmToken'])
        },
        computed: {
            ...mapGetters(['fcmToken', 'fcmData', 'pageVisibility']),
            ...gettersUser(['userSession'])
        },
        watch: {
            fcmToken(val, old) {
                if (val !== old && !!val && this.userSession.fcm_token !== val) {
                    this.updateFcmToken(val);
                }
            },
            fcmData(fcmData) {

                console.log(fcmData);

                if (!!fcmData && !!fcmData.data && !!fcmData.data.notification) {

                    const notification = JSON.parse(fcmData.data.notification);
                    const {name: userName} = this.$appStorage.getUser();

                    if (this.pageVisibility !== 'visible') {
                        const messageOptions = Object.assign({}, {
                            icon: '/assets/icons/icon-96x96.png'
                        }, notification);

                        let n = new Notification(userName, messageOptions);
                        n.addEventListener('click', e => {
                            n.close();
                        })
                    } else {
                        const {type} = notification;
                        if (/(warning|success|danger|info)/gi.test(type)) {
                            this.$snotify[type](notification.body, userName);
                        } else {
                            this.$snotify.simple(notification.body, userName);
                        }
                    }
                }
            }
        }
    }
</script>
